module.exports = __webpack_public_path__ + "static/media/cppsecrets.587bf55d.png";